export default "__VITE_ASSET__BmMb2aQs__"